import type {TNode} from 'ghostban';
import type {ScenarioToMove} from '@types';
import {useTranslation} from 'react-i18next';

type ToMoveIndicatorProps = {
    currentNode?: TNode | null | undefined;
    initialToMove: ScenarioToMove;
};

const getNextToMove = (
    currentNode: TNode | null | undefined,
    initialToMove: ScenarioToMove
): 'b' | 'w' => {
    if (!currentNode) return initialToMove;

    const lastMove = currentNode.model.moveProps?.[0];
    if (!lastMove) return initialToMove;

    const lastToken = lastMove.token;
    if (lastToken === 'W') return 'b';
    if (lastToken === 'B') return 'w';

    return initialToMove;
};

export const ToMoveIndicator = ({
    currentNode,
    initialToMove,
}: ToMoveIndicatorProps) => {
    const {t} = useTranslation();
    const nextToMove = getNextToMove(currentNode, initialToMove);
    const isWhite = nextToMove === 'w';

    return (
        <div className="flex items-center gap-2">
            {isWhite ? (
                <div className="rounded-full h-4 w-4 bg-white border border-black flex-shrink-0"></div>
            ) : (
                <div className="rounded-full h-4 w-4 bg-black flex-shrink-0"></div>
            )}
            <span className="text-sm text-body-secondary">
                {t(isWhite ? 'go.white_to_move' : 'go.black_to_move')}
            </span>
        </div>
    );
};
